module.exports = __webpack_public_path__ + "img/frame (150).1c1e6a92.jpg";